import { ButtonPrimary, TextL, TextM, TextS, TextXs } from 'app/components';
import {
  TableBodyCellContainer,
  TableHeadCellContainer,
} from 'app/styles/components/Table';
import { formatCurrency } from 'app/utils/normalizer';
import { TQualificationWithStatusAndProduct } from 'modules/customer/interfaces/qualifications';
import dayjs from 'dayjs';
import { EQualificationLabel } from 'modules/products/context/QualificationsProvider/qualifications.interfaces';

export const tableQualificationHeader = [
  {
    id: '5',
    content: (
      <TableHeadCellContainer style={{ textAlign: 'center' }}>
        <TextL weight="bold">Status</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '3',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Criado</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '1',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Atualizado</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '2',
    content: (
      <TableHeadCellContainer>
        <TextL weight="bold">Produto</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '4',
    content: (
      <TableHeadCellContainer style={{ textAlign: 'center' }}>
        <TextL weight="bold">Limite total</TextL>
      </TableHeadCellContainer>
    ),
  },
  {
    id: '6',
    content: (
      <TableHeadCellContainer style={{ textAlign: 'center', width: '100%' }}>
        <TextL weight="bold">Ações</TextL>
      </TableHeadCellContainer>
    ),
  },
];

export const renderQualificationTableContent = (
  qualification: TQualificationWithStatusAndProduct | null,
  setSelectedQualification: (
    qualification?: TQualificationWithStatusAndProduct,
  ) => void,
) => {
  return [
    {
      id: '5',
      content: (
        <TableBodyCellContainer>
          <TextM>
            {EQualificationLabel[
              qualification?.status as keyof typeof EQualificationLabel
            ] || 'Não informado'}
          </TextM>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '3',
      content: (
        <TableBodyCellContainer>
          <TextS>
            {qualification?.created_at
              ? `${dayjs(qualification?.created_at || '').format('DD/MM/YYYY')}
                                às ${dayjs(qualification?.created_at).format(
                                  'HH:mm:ss',
                                )}`
              : 'Não informado'}
          </TextS>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '1',
      content: (
        <TableBodyCellContainer>
          <TextS>
            {qualification?.updated_at
              ? `${dayjs(qualification?.updated_at || '').format('DD/MM/YYYY')}
                                às ${dayjs(qualification?.updated_at).format(
                                  'HH:mm:ss',
                                )}`
              : 'Não informado'}
          </TextS>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '2',
      content: (
        <TableBodyCellContainer>
          <TextS weight="Bold">{qualification?.product?.name}</TextS>
          <TextXs>{qualification?.product?.description}</TextXs>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '4',
      content: (
        <TableBodyCellContainer>
          <TextS>
            {formatCurrency(
              qualification?.condition?.line_of_credit?.credit_limit || 0,
            )}
          </TextS>
        </TableBodyCellContainer>
      ),
    },
    {
      id: '6',
      content: (
        <TableBodyCellContainer
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginLeft: '0px',
          }}
        >
          <ButtonPrimary
            typeVariant="ghost"
            style={{ width: 'fit-content' }}
            onClick={() => setSelectedQualification(qualification || undefined)}
          >
            Acessar
          </ButtonPrimary>
        </TableBodyCellContainer>
      ),
    },
  ];
};
